import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

type RenderFunction = (props: {
  attributes: ReturnType<typeof useSortable>["attributes"];
  isDragging: boolean;
  listeners: ReturnType<typeof useSortable>["listeners"];
}) => React.ReactNode;

type SortableItemProps = {
  id: string;
  render: RenderFunction;
};

export function SortableItem({ id, render }: SortableItemProps) {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 10 : undefined,
  };

  return (
    <li ref={setNodeRef} style={style}>
      {render({
        attributes,
        isDragging,
        listeners,
      })}
    </li>
  );
}
